import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AiProvider } from '../utils/aiNames'

type BulkSettings = {
  baseEmail: string
  count: number
  startAt: number
  provider: AiProvider
  apiKey: string
  prompt: string
  model: string
  setBaseEmail: (s: string) => void
  setCount: (n: number) => void
  setStartAt: (n: number) => void
  setProvider: (p: AiProvider) => void
  setApiKey: (k: string) => void
  setPrompt: (p: string) => void
  setModel: (m: string) => void
}

export const useBulk = create<BulkSettings>()(
  persist(
    (set) => ({
      baseEmail: '',
      count: 5,
      startAt: 1,
      provider: 'openai',
      apiKey: '',
      prompt: 'fictional indie tabletop game designers in their late 20s',
      model: '',
      setBaseEmail: (baseEmail) => set({ baseEmail }),
      setCount: (count) => set({ count: Math.max(1, Math.min(500, count | 0)) }),
      setStartAt: (startAt) => set({ startAt: Math.max(0, startAt | 0) }),
      setProvider: (provider) => set({ provider }),
      setApiKey: (apiKey) => set({ apiKey }),
      setPrompt: (prompt) => set({ prompt }),
      setModel: (model) => set({ model }),
    }),
    { name: 'bskydisc.bulk' },
  ),
)
